module.exports = __webpack_public_path__ + "static/scale-model-of-north-boulder-park-in-boulder-colorado-e907ad7d226d853a5ba3454d7bb963ac.png";